import React, { Component } from "react";
import { Col, Row } from "react-flexbox-grid";
import { CardColor, Loader } from "ui-kit-ck-consultant";

import axiosConfig from "../../../utils/axiosConfig";
import AuthContext from "../../../context/AuthContext";
import WidgetWrapper from "./WidgetWrapper";

export default class WidgetTeamOverview extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoad: true,
      nbInterview: 0,
      nbSIM: 0,
      nbAudit: 0,
      nbAuditPA: 0,
    };
  }

  static contextType = AuthContext;

  componentDidMount() {
    let loaded = 0;
    const total = 4;
    const checkLoaded = () => {
      loaded++;
      if (loaded >= total) this.setState({ isLoad: false });
    };

    axiosConfig("home/count-interview").then((res) => {
      if (res.data.success) this.setState({ nbInterview: res.data.data });
      checkLoaded();
    });

    axiosConfig("home/count-sim").then((res) => {
      if (res.data.success) this.setState({ nbSIM: res.data.data });
      checkLoaded();
    });

    axiosConfig("home/count-audit").then((res) => {
      if (res.data.success) this.setState({ nbAudit: res.data.data });
      checkLoaded();
    });

    axiosConfig("home/count-audit-pa").then((res) => {
      if (res.data.success) this.setState({ nbAuditPA: res.data.data });
      checkLoaded();
    });
  }

  render() {
    const { isLoad, nbInterview, nbSIM, nbAudit, nbAuditPA } = this.state;
    const role = Number(this.context.role);

    const title =
      role === 1
        ? "Vue équipe - Experts"
        : role === 2
        ? "Vue équipe - Assistants"
        : "Vue équipe";

    return (
      <WidgetWrapper
        title={title}
        isCustomizing={this.props.isCustomizing}
        dragHandleProps={this.props.dragHandleProps}
        onHide={this.props.onHide}
      >
        {isLoad ? (
          <Loader />
        ) : (
          <Row>
            <Col xs={12} md={3}>
              <CardColor
                title="Entretiens en attente"
                count={nbInterview}
                className={`mb-10 ${nbInterview === 0 ? "bg-green" : "bg-orange"}`}
              />
            </Col>
            <Col xs={12} md={3}>
              <CardColor
                title="SIM en attente"
                count={nbSIM}
                className={`mb-10 ${nbSIM === 0 ? "bg-green" : "bg-orange"}`}
              />
            </Col>
            <Col xs={12} md={3}>
              <CardColor
                title="Audits réalisés"
                count={nbAudit}
                className="mb-10 bg-blue"
              />
            </Col>
            <Col xs={12} md={3}>
              <CardColor
                title="Audits PA réalisés"
                count={nbAuditPA}
                className="mb-10 bg-blue"
              />
            </Col>
          </Row>
        )}
      </WidgetWrapper>
    );
  }
}
